export default __webpack_public_path__ + "static/media/endless youth.19377a08.jpg";